export default __webpack_public_path__ + "static/media/USDT.f1798e99.svg";